import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const Section = ({ title, className = '', children, visible = true, onVisible, unmount = false }) => {
  const [showBody, setShowBody] = useState(visible);

  useEffect(() => {
    setShowBody(visible);
  }, [visible]);

  return (
    <div className={`section ${className} ${showBody ? '' : 'hidden'}`}>
      {!!title && (
        <div role="button" className="title" onClick={() => {
          setShowBody(!showBody);
          onVisible && onVisible(!showBody);
        }}>
          {title}
        </div>
      )}
      {(!unmount || showBody) && (
        <div className="section-body">
          {children}
        </div>
      )}
    </div>
  );
};

Section.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  visible: PropTypes.bool,
  onVisible: PropTypes.func,
  unmount: PropTypes.bool
};

export default Section;
